import React, { Suspense, useEffect, useState } from 'react';
// import { getLazyComponent } from '../Basic/Menu';
// import PageLevelComponents from './PageLevel/PageLevelComponents';
// import AppNavbar from '../AppNavbar/AppNavbar'
import { AppContextProvider } from './PageLevel/AppContextProvider';
import './App.scss'
import { RouterAndView } from './RouterAndView';
import PageLevelComponents from './PageLevel/PageLevelComponents';
import { AppStorage } from '../Basic/storage-service';

function App() {
  useEffect(() => {
    const checkActiveVersion = async () => {
      try {
        const res = await fetch(`/version.json?cb=${Date.now()}`, {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        if (!res.ok) return;
        const data = await res.json();
        const activeVersion = data.version;
        const localAppVersion = window?._ENV_?.app_version;
        const loggedInVersion = AppStorage.getLoggedInUIVersion();

        if (activeVersion && ((localAppVersion && activeVersion !== localAppVersion) || (loggedInVersion && activeVersion !== loggedInVersion))) {
          console.warn('[SECURITY] App version mismatch detected. Performing auto-logout.');
          AppStorage.performLogout();
          window.location.href = '/';
        }
      } catch (e) {
        console.error('Failed to poll version.json', e);
      }
    };

    // 1. Storage Listener for multi-tab sync.
    // The browser `storage` event reports the PHYSICAL key name, which is
    // obfuscated in production (e.g. _token_ -> _x3t_). Resolve the physical keys
    // once via AppStorage.getPhysicalKey so this matches in prod without hardcoding
    // the obfuscated literals (which would silently drift from KEY_MAP).
    const TOKEN_KEY = AppStorage.getPhysicalKey('_token_');
    const LOGIN_UPDATED_AT_KEY = AppStorage.getPhysicalKey('_login_info_updated_at_');
    const handleStorage = (event) => {
      // Logout elsewhere: clear() fires with event.key === null; an explicit token
      // removal fires with the token key and no newValue.
      if (event.key === null || event.key === TOKEN_KEY) {
        if (event.key === null || !event.newValue) {
          sessionStorage.clear();
          window.location.href = '/';
        }
      }
      // Login elsewhere: performLogin writes the login-detection key LAST.
      if (event.key === LOGIN_UPDATED_AT_KEY && event.newValue) {
        window.location.reload();
      }
    };
    window.addEventListener('storage', handleStorage);

    // 2. Active version polling every 15 minutes
    const intervalId = setInterval(checkActiveVersion, 15 * 60 * 1000);

    // 3. Check version on tab focus
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkActiveVersion();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 4. Check version on bfcache restore (mobile / Android Home button). A page
    // restored from the back-forward cache keeps running its OLD JS bundle; if a
    // new build deployed meanwhile its chunks are 404s. pageshow.persisted is the
    // reliable "restored from bfcache" signal, so re-verify the version (which
    // logs out + reloads on mismatch) to avoid stale UI / blank pages.
    const handlePageShow = (event) => {
      if (event.persisted) {
        checkActiveVersion();
      }
    };
    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('storage', handleStorage);
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  return (
    <AppContextProvider>
      <RouterAndView />
      <PageLevelComponents></PageLevelComponents>
    </AppContextProvider>
  );
}

export default App;
